/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pliObservable = require("../forms-knockoutcontrols-date");
var stringUtil = require("../util/string");

var shared = require("./shared");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// RangeAdvancedSearchItem template
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var parseRangeRegex = new RegExp("(.+)(?:\\.\\.)(.+)|(>=|<=)*(.*)");


//-------------------------------------------
function RangeAdvancedSearchItem(behaviourName, behaviourData) {
    if (!(this instanceof RangeAdvancedSearchItem)) { return new RangeAdvancedSearchItem(); } // if new was not used, force it now

    // indicates how number fields are searched
    // - `equals` includes any items that match the number exactly.
    // - `between` includes any items between the numbers specified including the numbers themselves. (default)
    // - `not` excludes any items that match the number exactly.
    // - `>=` includes any items greater than or equal to the number specified.
    // - `<=` incluces any items less than or equal to the number specified.
    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
    this.operator = ko.observable("equals");

    this.behaviourName = behaviourName;
    this.lower = pliObservable(null, behaviourData, behaviourName); // lower is used for `<=`, `>=` and `equals`
    this.upper = pliObservable(null, behaviourData, behaviourName);

    // extras
    this.extras = function rangeAdvancedSearchItemExtras() { return; };
    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
}


//-------------------------------------------
RangeAdvancedSearchItem.prototype.templateId = "rangeAdvancedSearchItem";


//-------------------------------------------
// Loads the value of this view-model from the
// advancedSearch item.
RangeAdvancedSearchItem.prototype.load = function rangeAdvancedSearchItemLoad(phrase, not) {
    var operatorValue = "equals",
        lower = null,
        upper = null,
        range = parseRangeRegex.exec(phrase) || [],
        lowerRange = range[1],
        upperRange = range[2],
        operator = range[3],
        value = range[4];

    if (!stringUtil.isNullOrWhitespace(lowerRange) && !stringUtil.isNullOrWhitespace(upperRange)) {
        lower = lowerRange;
        upper = upperRange;
        operatorValue = "between";
    } else if (value === "[empty]") {
        operatorValue = not ? "is not empty" : "is empty";
    } else {
        lower = typeof value === "string" ? value : null;
        operatorValue = not ? "not" : (operator || operatorValue);
    }

    this.lower.load(lower);
    this.upper.load(upper);
    this.operator(operatorValue);
};



//-------------------------------------------
// Saves the value of this view-model to the
// advancedSearch item. Expects `this` to be the advancedSearch item.
RangeAdvancedSearchItem.prototype.save = function  rangeAdvancedSearchItemSave() {
    this.lower();
    this.upper();
    var phrase = "",
        not = false,
        operator = this.operator(),
        lower = this.lower.format(),
        upper = this.upper.format();

    switch (operator) {
    case ">=":
        if (lower) {
            phrase = ">=" + lower;
        }
        break;
    case "<=":
        if (lower) {
            phrase = "<=" + lower;
        }
        break;
    case "equals":
        phrase = "".concat(lower);
        break;
    case "between":
        if (lower && upper) {
            phrase = lower + ".." + upper;
            break;
        }
        if (lower) {
            phrase = ">=" + lower;
            break;
        }
        if (upper) {
            phrase = "<=" + upper;
            break;
        }
        break;
    case "not":
        phrase = "".concat(lower);
        not = true;
        break;
    case "is empty":
        phrase = "[empty]";
        not = false;
        break;
    case "is not empty":
        phrase = "[empty]";
        not = true;
        break;
    }

    return [phrase, not];
};


//-------------------------------------------
function initializeRangeAdvancedSearch(behaviour, templateId, defaultValue) {

    var f = function (behaviourData) {
        return new RangeAdvancedSearchItem(behaviour, behaviourData);
    };

    f.prototype.templateId = (!!templateId && typeof templateId === "string") ? templateId : RangeAdvancedSearchItem.prototype.templateId;
    f.prototype.defaultValue = defaultValue;

    return f;
}

module.exports = {
    date: initializeRangeAdvancedSearch("date"),
    initializeRangeAdvancedSearch: initializeRangeAdvancedSearch,
    number: initializeRangeAdvancedSearch("numeric")
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/rangeAdvancedSearchItem.js
// module id = 448
// module chunks = 49